<a180-common-card
  [title]="'No Show Appointments'"
>
  <ion-text [color]="updateAppointmentResponse?.message?.status" class="fw-700">
    {{ updateAppointmentResponse?.message?.content }}
  </ion-text>
  <br><br>
  <ion-text class="fw-500">
    <span *ngIf="noShowAppointments.length">
      Here's the client's recent appointment history:
    </span>
    <br>
  </ion-text>
  <ion-list>
    <ion-item *ngFor="let appointment of noShowAppointments">
      <ion-label>{{ appointment.start_date_time | date:'short' }}</ion-label>

      <ion-icon *ngIf="appointment.internal_status === 'scheduled'" name="checkmark-circle" color="success" slot="start"></ion-icon>
      <ion-label color="success" slot="end" *ngIf="appointment.internal_status === 'scheduled'">
        Scheduled
      </ion-label>

      <ion-icon *ngIf="appointment.internal_status === 'cancelled'" name="alert-circle" color="warning"
        slot="start"></ion-icon>
      <ion-label color="warning" slot="end" *ngIf="appointment.internal_status === 'cancelled'">Cancelled</ion-label>

      <ion-icon *ngIf="appointment.internal_status === 'no_show' || appointment.no_show" name="close-circle" color="danger"
        slot="start"></ion-icon>
      <ion-label color="danger" slot="end" *ngIf="(appointment.internal_status === 'no_show' || appointment.no_show)">No Show</ion-label>
    </ion-item>
  </ion-list>
  <br>
  <ion-text class="fw-500" *ngIf="updateAppointmentResponse?.message?.status !== 'danger'">
    You may send an email to the client letting them know they missed their appointment.  Please choose from one of the following emails:
  </ion-text>

  <ion-text class="fw-500" *ngIf="updateAppointmentResponse?.message?.status === 'danger'">
    You may not send an email to the client letting them know they missed their appointment.
  </ion-text>

  <ion-list class="mt-3">
    <ion-item *ngFor="let option of emailOptions" button (click)="emailOptionSelected(option)" [disabled]="updateAppointmentResponse?.message?.status === 'danger'">
      <ion-label>{{ option.label }}</ion-label>
    </ion-item>
  </ion-list>

</a180-common-card>